// imports
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

//components
import { PasswordSuccessIcon } from 'assets/svgs';
import { AuthLayout } from 'components/common/AuthLayout';

//constants
import {
  AUTH_LINKS,
  EMAIL_SENT_SUCCESS_SUBTITLE,
  EMAIL_SENT_SUCCESS_TITLE,
  GO_TO_SIGNIN_BUTTON,
} from 'constants/index';

//lib
import { trackSignupSuccess } from 'lib/ga4';

const EmailSentSuccess: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Track signup success conversion for GA4
    trackSignupSuccess();
  }, []);

  return (
    <AuthLayout
      title={EMAIL_SENT_SUCCESS_TITLE}
      subTitle={EMAIL_SENT_SUCCESS_SUBTITLE}
      icon={<PasswordSuccessIcon />}>
      <Button fullWidth variant="contained" color="primary" onClick={() => navigate(AUTH_LINKS.LOGIN_LINK)}>
        {GO_TO_SIGNIN_BUTTON}
      </Button>
    </AuthLayout>
  );
};

export default EmailSentSuccess;
